<!--
* 组件名 : 迫害报告数据
* 开发者 : JY
*
* 参数:
*   data             { Object } -  迫害报告数据
*
* 事件: null
*
-->

<template>
  <div class="persecution-total-section">
    <persecution-situation
      :statisticsList="data.statisticsList"
      :title="data.title"
      :totalNum="data.pictures.title"
      ref="persecutionSituation"
    />
    <div
      class="person-info-wrap d-flex flex-wrap"
      v-if="data.pictures"
      ref="personInfoWrap"
    >
      <person-info
        :name="item.name"
        :description="item.description"
        :poster="item.poster"
        v-for="(item, i) in data.pictures.list"
        :key="i"
      />
    </div>
  </div>
</template>

<script>
import { timeout } from "@/utils/util";
import PersecutionSituation from "./components/persecution-situation/index.vue";
import PersonInfo from "./components/person-info/index.vue";

export default {
  name: "persecution-total-section",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  components: {
    PersecutionSituation,
    PersonInfo,
  },
};
</script>

<style lang="scss">
.persecution-total-section {
  .person-info-wrap {
    width: 900px;
    margin: auto;
    padding-bottom: 170px;
  }

  @media (min-width: $lx-min) {
    .person-info-wrap {
      width: 1274px;
    }
  }
}
</style>
